const AUTH_CHANNEL_NAME = "lodos_auth_channel";
const AUTH_CHANNEL_SUPPRESS_KEY = "AUTH_SUPPRESS_REDIRECT_UNTIL";

let authChannel = null;
const subscribers = new Set();

function initChannel() {
  if (authChannel) return authChannel;
  if (typeof window === "undefined" || !("BroadcastChannel" in window)) return null;

  try {
    authChannel = new BroadcastChannel(AUTH_CHANNEL_NAME);
    authChannel.onmessage = (event) => {
      const data = event.data;
      subscribers.forEach((cb) => {
        try {
          cb(data);
        } catch {
          // ignore
        }
      });
    };
    return authChannel;
  } catch {
    return null;
  }
}

export function broadcastAuthMessage(data) {
  const channel = initChannel();
  if (channel) {
    try {
      channel.postMessage(data);
    } catch {
      // ignore
    }
  }

  // Also use localStorage for cross-tab sync
  try {
    localStorage.setItem("auth_sync", JSON.stringify({ ...data, ts: Date.now() }));
  } catch {
    // ignore
  }
}

export function subscribeAuthMessage(callback) {
  initChannel();
  subscribers.add(callback);

  // Also listen to localStorage changes
  const handleStorage = (event) => {
    if (event.key === "auth_sync" && event.newValue) {
      try {
        const data = JSON.parse(event.newValue);
        callback(data);
      } catch {
        // ignore
      }
    }
  };

  if (typeof window !== "undefined") {
    window.addEventListener("storage", handleStorage);
  }

  return () => {
    subscribers.delete(callback);
    if (typeof window !== "undefined") {
      window.removeEventListener("storage", handleStorage);
    }
  };
}

export function isRedirectSuppressed() {
  try {
    const raw = sessionStorage.getItem(AUTH_CHANNEL_SUPPRESS_KEY);
    const until = raw ? parseInt(raw, 10) : 0;
    return Number.isFinite(until) && Date.now() < until;
  } catch {
    return false;
  }
}

export function setRedirectSuppress(durationMs = 8000) {
  try {
    sessionStorage.setItem(AUTH_CHANNEL_SUPPRESS_KEY, String(Date.now() + durationMs));
  } catch {
    // ignore
  }
}
